/**
 * Utilidades de descarga de archivos vía blob.
 *
 * Los endpoints protegidos se consumen con axios (Bearer token), por lo que el
 * archivo llega como blob y no se puede usar un <a href> directo a la URL. Antes
 * se abría con `window.open(blobUrl)`, pero al guardar desde el visor del
 * navegador el archivo tomaba como nombre el UUID del object URL
 * (p. ej. "57968953-ab7c-…"). Aquí forzamos la descarga con <a download> y un
 * nombre legible, preferentemente el que el backend ya envía en Content-Disposition.
 */

/** Extrae el filename de un header Content-Disposition (soporta filename*=UTF-8''…). */
export function nombreDesdeContentDisposition(cd?: string | null): string | null {
  if (!cd) return null;
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(cd);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ""));
    } catch {
      /* cae al filename simple */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(cd);
  return plain ? plain[1].trim() : null;
}

/** Dispara la descarga de un blob con un nombre de archivo explícito. */
export function descargarBlob(data: BlobPart, nombre: string, tipo = "application/pdf"): void {
  const blob = new Blob([data], { type: tipo });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // El navegador ya copió el blob; liberar memoria después de un rato.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * Descarga la respuesta blob de axios usando el nombre de Content-Disposition
 * cuando está disponible, o {@code nombreFallback} en su defecto.
 */
export function descargarRespuestaBlob(
  resp: { data: BlobPart; headers: Record<string, unknown> },
  nombreFallback: string,
  tipo = "application/pdf",
): void {
  const cd = resp.headers["content-disposition"] as string | undefined;
  descargarBlob(resp.data, nombreDesdeContentDisposition(cd) ?? nombreFallback, tipo);
}
